import React, { FC } from 'react'

const SkeletonStory: FC = () => (
  <div className="pd-skeleton-story">
    <div className="pd-skeleton-story__header pd-skeleton__flex">
      <div className="pd-skeleton__avatar pd-skeleton__avatar--light" />
      <div className="pd-skeleton__line pd-skeleton__line--light pd-skeleton__artist-info" />
    </div>
    <div className="pd-skeleton-story__body">
      <div className="pd-skeleton-story__info" />
      <div className="pd-skeleton__flex">
        <div className="pd-skeleton__line pd-skeleton-story__tag" />
        <div className="pd-skeleton__line pd-skeleton-story__tag" />
      </div>
    </div>
    <div className="pd-skeleton-story__footer" />
  </div>
)

export default SkeletonStory
